import { useEffect, useRef, useState } from "react";

import { WordSearchGameStatus } from "../../word-search/word-search.types";

export function ArcadeTimer({
  isRunning,
  time,
  onTimeout,
  gameStatus,
}: {
  isRunning: boolean;
  time: number;
  onTimeout: () => void;
  gameStatus?: WordSearchGameStatus;
}) {
  const [timeLeft, setTimeLeft] = useState(time);
  const [callTimeOut, setCallTimeOut] = useState<boolean>(false);
  const interval = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!gameStatus) {
      return;
    }
    if (gameStatus === WordSearchGameStatus.IDLE) {
      setTimeLeft(time);
    }
  }, [gameStatus, time]);

  useEffect(() => {
    if (isRunning) {
      interval.current = setInterval(() => {
        setTimeLeft((current) => {
          if (current <= 0) {
            setCallTimeOut(true);
            clearInterval(interval.current!);
            return 0;
          }

          return current - 1;
        });
      }, 1000);
    } else {
      if (interval.current) clearInterval(interval.current);
    }

    return () => {
      if (interval.current) clearInterval(interval.current);
    };
  }, [isRunning]);

  useEffect(() => {
    if (callTimeOut) {
      onTimeout();
      setCallTimeOut(false);
    }
  }, [callTimeOut, onTimeout]);

  return (
    <div className="arcade--timer">
      <span>
        {timeLeft === 0 ? (
          <span>:00</span>
        ) : timeLeft > 59 ? (
          <span>
            {`${Math.floor(timeLeft / 60)}:${
              timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60
            }`}
          </span>
        ) : (
          <span> :{timeLeft < 10 ? `0${timeLeft}` : timeLeft} </span>
        )}
      </span>
      <svg>
        <defs>
          <linearGradient id="gradient" x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="10%" stopColor="#ffde00" />
            <stop offset="45%" stopColor="#ff8059" />
            <stop offset="85%" stopColor="#e397ff" />
            <stop offset="100%" stopColor="#64e5f4" />
          </linearGradient>
        </defs>
        <circle
          r="29"
          cx="31"
          cy="32"
          stroke="url(#gradient)"
          style={
            timeLeft === 0
              ? { stroke: "#ff5e51" }
              : isRunning
              ? {
                  animation: `arcade-countdown ${time}s linear infinite`,
                }
              : {}
          }
          data-testid="countdown-svg-circle"
        />
      </svg>
    </div>
  );
}
